import { OnInit, ChangeDetectorRef, ElementRef } from '@angular/core';
import { UsersService } from 'src/app/modules/shared/services/users.service';
import { Constants } from 'src/app/modules/shared/config/constants.config';
import { ThemeService } from '../../../shared/services/theme.service';
import { AppLoadingEventsEmitter } from '../../../shared/events/loading.events';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { MasterService } from '../../../shared/services/master.service';
import { DiaryService } from '../../../shared/services/diary.service';
import { forkJoin } from 'rxjs';
import * as moment from 'moment';
var MessagesComponent = /** @class */ (function () {
    function MessagesComponent(usersService, changeDetectorRef, themeService, constants, router, route, masterService, diaryService, appLoadingEventsEmitter, authService) {
        this.usersService = usersService;
        this.changeDetectorRef = changeDetectorRef;
        this.themeService = themeService;
        this.constants = constants;
        this.router = router;
        this.route = route;
        this.masterService = masterService;
        this.diaryService = diaryService;
        this.appLoadingEventsEmitter = appLoadingEventsEmitter;
        this.authService = authService;
        this.chatMessage = '';
        this.chatMessages = [];
    }
    MessagesComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            forkJoin(_this.usersService.getUserProfile(), _this.masterService.getUserProfile(params['id']))
                .subscribe(function (_a) {
                var masterProfile = _a[0], user = _a[1];
                _this.masterUser = masterProfile;
                _this.user = user;
                _this.changeDetectorRef.markForCheck();
                _this.loadChatMessage();
            });
        });
    };
    MessagesComponent.prototype.linkClickable = function (text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g; // regex for both http:// and https://
        return text.replace(urlRegex, function (url) {
            return '<a href="' + url + '" target="_blank">линк</a>'; // return the replaced text
        });
    };
    MessagesComponent.prototype.loadChatMessage = function () {
        var _this = this;
        this.diaryService.getMasterChatMessages(this.user.id).subscribe(function (data) {
            var messages = data.messages;
            for (var i = 0; i < messages.length; i++) {
                messages[i].message = _this.linkClickable(messages[i].message);
            }
            _this.chatMessages = messages;
            _this.changeDetectorRef.markForCheck();
            if (_this.chat) {
                setTimeout(function () {
                    _this.chat.nativeElement.scrollTop = 999999999999999;
                }, 500);
            }
            _this.changeDetectorRef.markForCheck();
        });
    };
    MessagesComponent.prototype.sendMessage = function () {
        var _this = this;
        this.diaryService.postMasterChatMessages(this.user.id, this.masterUser.id, this.chatMessage).subscribe(function () {
            _this.chatMessage = '';
            _this.changeDetectorRef.markForCheck();
            _this.loadChatMessage();
        });
    };
    MessagesComponent.prototype.openUserMeals = function (profile) {
        var _this = this;
        this.masterService.masterLogin(profile.id).subscribe(function (token) {
            _this.authService.setStorageItem('original_logged_token', _this.authService.getJWT());
            _this.authService.setStorageItem('master_sub_profile_logged_token', token.token);
            // this.authService.setJWT(this.authService.getStorageItem('master_sub_profile_logged_token'));
            _this.router.navigate(['/master/meals', profile.id]);
        });
    };
    MessagesComponent.prototype.openMessages = function (profile) {
        this.router.navigate(['/master/messages', profile.id]);
    };
    MessagesComponent.prototype.formatCreatedTime = function (date) {
        return moment(date).format('HH:mm ч. / DD.MM.YYYY');
    };
    return MessagesComponent;
}());
export { MessagesComponent };
